// Mirrors kilobyte.zookeeper.utils.pdf.WarehouseLabelFormats on the backend -
// same id strings, kept in sync manually (this codebase already duplicates
// enums like Permissions/Roles between front/backend the same way).
export const PRINTING_METHODS = {
  SHEET: "SHEET",
  ROLL: "ROLL",
};

export const SHEET_FORMATS = [
  { id: "SHEET_6", labelsPerSheet: 6, widthMm: 99.1, heightMm: 93.1 },
  { id: "SHEET_8", labelsPerSheet: 8, widthMm: 99.1, heightMm: 67.7 },
  { id: "SHEET_10", labelsPerSheet: 10, widthMm: 99.1, heightMm: 57 },
  { id: "SHEET_12", labelsPerSheet: 12, widthMm: 99.1, heightMm: 42.3 },
  { id: "SHEET_21", labelsPerSheet: 21, widthMm: 63.5, heightMm: 38.1 },
];

export const ROLL_FORMATS = [
  { id: "ROLL_40X30", widthMm: 40, heightMm: 30 },
  { id: "ROLL_50X30", widthMm: 50, heightMm: 30 },
  { id: "ROLL_58X40", widthMm: 58, heightMm: 40 },
  { id: "ROLL_60X40", widthMm: 60, heightMm: 40 },
  { id: "ROLL_100X50", widthMm: 100, heightMm: 50 },
];

export function getFormatsForMethod(method) {
  return method === PRINTING_METHODS.ROLL ? ROLL_FORMATS : SHEET_FORMATS;
}

export function formatLabel(format, t) {
  const size = `${format.widthMm}×${format.heightMm}mm`;
  return format.labelsPerSheet
    ? `${format.labelsPerSheet} ${t("LabelsPerSheet")} (${size})`
    : size;
}
